import React, { Fragment, useContext } from "react";

import withClass from "../../../hoc/withClass";
import classes from "./Logo.module.css";
import logoImage from "../../../assets/images/eboard-logo.png";
import context from "../../../context/auth-context";
import { Box, ThemeProvider, Typography } from "@mui/material";
import { theme } from "components/Content/Meetings/Main/Meeting/Details/InProgress/InprogressStepper";

const EboardLogo = () => {
  const authContext = useContext(context);
  const [isHovered, setHovered] = React.useState(false);
  return (
    <ThemeProvider theme={theme}>
      <Fragment>
        <img src={logoImage} alt="eBoard Logo" />
        <br />
        <div className="text-center" style={{ marginTop: "16px" }}>
          <Box
            border={(theme) => `1px solid ${theme.palette.success.light}`}
            bgcolor={(theme) =>
              isHovered ? theme.palette.success.main : "transparent"
            }
            borderRadius={1}
            minWidth="max-content"
            px={0.4}
            py={0}
            onMouseOver={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            sx={{
              userSelect: "none",
              cursor: "default",
            }}
          >
            <Typography
              color={(theme) =>
                isHovered
                  ? theme.palette.success.contrastText
                  : theme.palette.success.light
              }
              fontSize=".95rem"
            >
              <b>CURRENT COMPANY: </b>
              {authContext.companyName?.toUpperCase()}
            </Typography>
          </Box>
          {/* <span className="badge badge-dark badge-success" style={{ fontSize: '.98em' }}><b>CURRENT COMPANY: </b>{authContext.companyName?.toUpperCase()}</span> */}
        </div>
      </Fragment>
    </ThemeProvider>
  );
};

export default withClass(EboardLogo, classes.EboardLogo);
